'use client';

import type { IStepProgress } from '@repo/sdk';
import { Badge } from '@repo/ui';
import { Check, Circle, Loader2 } from 'lucide-react';
import type { JSX } from 'react';

interface IPipelineStepBadgeProps {
  step: IStepProgress | boolean;
  label?: string;
}

export function PipelineStepBadge({ step, label }: IPipelineStepBadgeProps): JSX.Element {
  if (typeof step === 'boolean') {
    return step ? (
      <Badge variant="default" className="bg-green-600 text-white gap-1">
        <Check className="size-3" />
        {label}
      </Badge>
    ) : (
      <Badge variant="outline" className="text-muted-foreground gap-1">
        <Circle className="size-3" />
        {label}
      </Badge>
    );
  }

  if (step.total === 0) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        -
      </Badge>
    );
  }

  if (step.done === step.total) {
    return (
      <Badge variant="default" className="bg-green-600 text-white gap-1">
        <Check className="size-3" />
        {step.done}
      </Badge>
    );
  }

  if (step.done > 0) {
    return (
      <Badge variant="secondary" className="gap-1">
        <Loader2 className="size-3" />
        {step.done}/{step.total}
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="text-muted-foreground">
      0/{step.total}
    </Badge>
  );
}
